import { loginWatcherSaga } from "./loginPage";
import { fork, all } from "redux-saga/effects";
import { appConfigWatcherSaga } from "./appConfigs";
import { projectWatcherSaga, registerProjectWatcherSaga, suspendProjectWatcherSaga } from "./project";
import { companyWatcherSaga, registerCompanyWatcherSaga, suspendCompanyWatcherSaga } from "./company";
import { registerUserWatcherSaga } from "./registerUser";
import { createJobCardWatcherSaga, fetchJobCardsWatcherSaga, fetchWorkspaceJobCardsWatcherSaga, viewJobWatcherSaga } from "./jobCard";
import { meterActivationWatcherSaga, assignContractorWatcherSaga, managementDecisionWatcherSaga, awaitingInspectorWatcherSaga, qualityControlWatcherSaga, failedExecutionWatcherSaga, assignTechnicianWatcherSaga, assignInspectorCompanyWatcherSaga } from './myWorkspace';
import {fetchUsersWatcherSaga, suspendUserWatcherSaga } from './users'
import { getJobAuditsWatcherSaga } from "./audit";
import { fetchMetersWatcherSaga, registerMeterWatcherSaga } from "./stockController";

export default function* rootSaga() {
  yield all([
    fork(loginWatcherSaga),
    fork(appConfigWatcherSaga),
    fork(projectWatcherSaga),
    fork(companyWatcherSaga),
    fork(createJobCardWatcherSaga),
    fork(fetchJobCardsWatcherSaga),
    fork(fetchWorkspaceJobCardsWatcherSaga),
    fork(registerUserWatcherSaga),
    fork(meterActivationWatcherSaga),
    fork(assignContractorWatcherSaga),
    fork(assignInspectorCompanyWatcherSaga),
    fork(managementDecisionWatcherSaga),
    fork(awaitingInspectorWatcherSaga),
    fork(qualityControlWatcherSaga),
    fork(failedExecutionWatcherSaga),
    fork(fetchUsersWatcherSaga),
    fork(registerCompanyWatcherSaga),
    fork(registerProjectWatcherSaga),
    fork(suspendProjectWatcherSaga),
    fork(suspendCompanyWatcherSaga),
    fork(suspendUserWatcherSaga),
    fork(viewJobWatcherSaga),
    fork(getJobAuditsWatcherSaga),
    fork(assignTechnicianWatcherSaga),
    fork(fetchMetersWatcherSaga),
    fork(registerMeterWatcherSaga),
  ])
}